import { BsGithub } from "react-icons/bs";
import { useState } from "react";
const Projects = () => {
  const [state] = useState([
    {
      id: 1,
      image: "./images/pro1.jpg",
      title: "MERN Stack blog",
      tag: "react express, redux, mongoDB, sass",
      github: "https://github.com/shakilkhan12/Youtube-Mern-Stack-Blog",
      website: "http://localhost:site.com",
    },
    {
      id: 2,
      image: "./images/pro2.jpg",
      title: "MERN Stack eCommerce",
      tag: "react, express, mongodb, Reduxtoolkit",
      github: "https://github.com/shakilkhan12/chawkbazar-eCommerce",
      website: "http://localhost:site.com",
    },
    {
      id: 3,
      image: "./images/project4.jpg",
      title: "React instagram clone",
      tag: "react firebase",
      github: "https://github.com/shakilkhan12/Y-InstagramClone",
      website: "http://localhost:site.com",
    },
    {
      id: 4,
      image: "./images/project5.jpg",
      title: "react messenger clone",
      tag: "react, firebase",
      github: "https://github.com/shakilkhan12/Y-MessengerClone",
      website: "http://localhost:site.com",
    },
    {
      id: 5,
      image: "./images/project6.jpg",
      title: "next, express reddit clone",
      tag: "next, express, mongoDB",
      github: "https://reddditclone.vercel.app",
      website: "http://localhost:site.com",
    },
    {
      id: 6,
      image: "./images/project8.jpg",
      title: "vue, vuex amazon clone",
      tag: "vue, vuex",
      github: "https://github.com/shakilkhan12/Youtube-vuejs-amazon-clone",
      website: "http://localhost:site.com",
    },
  ]);
  return (
    <div className="py-[90px] bg-white dark:bg-gray-900">
      <div className="container-block">
        <h1 className="heading">projects</h1>
        <div className="flex flex-wrap -mx-4">
          {state.map((project) => (
            <div
              className={`w-full ${
                project.id === 1
                  ? "md:w-6/12"
                  : project.id === 2
                  ? "md:w-3/12"
                  : project.id === 3
                  ? "md:w-3/12"
                  : "md:w-4/12"
              }  p-4`}
              key={project.id}
            >
              <div className="bg-white">
                <div className="w-full h-[300px] overflow-hidden relative">
                  <img
                    src={project.image}
                    className="w-full h-full object-cover"
                    alt=""
                  />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/90 dark:to-teal-900">
                    <a
                      href={project.github}
                      target="_blank"
                      className="flex items-center justify-center text-white absolute top-2 left-2 w-[30px] h-[30px] rounded-full bg-teal-500"
                    >
                      <BsGithub />
                    </a>
                    <div className="absolute bottom-6 right-4 left-4 ">
                      <span className="inline-block capitalize text-teal-300 font-semibold text-xs mb-2 dark:text-teal-200">
                        {project.tag}
                      </span>
                      <h2 className="text-white font-semibold capitalize text-lg leading-[22px]">
                        {project.title}
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
